"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatedFields = exports.FieldUpdated = exports.FieldCreated = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_date_time_field_1 = require("../../form/fields/form-date-time-field");
function FieldCreated() {
    return (react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "created", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_CREATED", defaultMessage: "Vytvo\u0159en\u00ED" }), disabled: true }));
}
exports.FieldCreated = FieldCreated;
function FieldUpdated() {
    return (react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "updated", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_UPDATED", defaultMessage: "Posledn\u00ED \u00FAprava" }), disabled: true }));
}
exports.FieldUpdated = FieldUpdated;
function DatedFields(options) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        options.FieldsComponent && react_1.default.createElement(options.FieldsComponent, null),
        react_1.default.createElement(FieldCreated, null),
        react_1.default.createElement(FieldUpdated, null)));
}
exports.DatedFields = DatedFields;
//# sourceMappingURL=dated-fields.js.map